/*
 * Date: 2020-08-02 14:02:17
 * LastEditors: Mosuzi
 * LastEditTime: 2020-08-02 14:41:31
 * Description: In User Settings Edit
 * Author: Mosuzi
 */
export default {
  module: 'TODO_CENTER',
  QUERY_MY_TODO_LIST: {
    url: '/xdap-app/process/query/todoList',
    methods: 'get',
    disableSuccessMsg: true
  },
  QUERY_MY_SUBMIT_LIST: {
    url: '/xdap-app/process/query/mySubmitList',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_MY_PARTICIPATE_LIST: {
    url: '/xdap-app/process/query/myParticipateList',
    method: 'get',
    disableSuccessMsg: true
  }
}
